<script setup lang="ts">
const route = useRoute()
const app = useAppConfig()

/**
 * Global head configuration
 * @see https://unhead.harlanzw.com/
 * @see https://github.com/unjs/unhead/tree/main
 */
useHead({
  title: computed(() => route.meta.title),
  titleTemplate: (titleChunk) => {
    return titleChunk
      ? `${titleChunk} - ${app.tairo.title}`
      : `${app.tairo.title || 'Tairo'}`
  },
})

defineOgImage({
  alt: 'Feestfiets',
  url: '/img/feestfiets.jpg',
})

const { locale } = useI18n()
const dayjs = useDayjs()
watch(locale, (value) => {
  dayjs.locale(value)
}, {
  immediate: true,
})
</script>

<template>
  <div>
    <NuxtLayout>
      
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>
